<template>
  <el-dialog
    v-if="dialogShow"
    v-model="dialogShow"
    :title="title"
    :close-on-click-modal="false"
    width="80%"
    top="10px"
    center
    destroy-on-close
  >
    <div class="data-table-container">
      <data-table
        ref="$data-table"
        :url="url"
        :requestData="requestData"
        :cell-style="cellStyle"
        :async="true"
        :border="border"
        :selection="selection"
        :stripe="stripe"
        :operationsWidth="operationsWidth"
        :page="page"
        :height="height"
        :statistics="statistics"
        :search="search"
        :opgroup="opgroup"
        :opfix="opfix"
        :fields="fields"
        :operations="operations"
        :tableOperations="tableOperations"
        :dataFilter="dataFilter"
        :customer="customer"
        :handleCellClick="handleCellClick"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'DialogTable',
  props: {
    title: {
      type: String,
      default: '弹窗表格'
    },
    url: {
      type: String,
      default: ''
    },
    requestData: {
      type: Object,
      default: () => {
        return undefined
      }
    },
    customer: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: false
    },
    operationsWidth: {
      type: Number,
      default: 300
    },
    page: {
      type: Number,
      default: 0
    },
    cellStyle: {
      type: [ Function, Boolean ],
      default: undefined
    },
    height: {
      type: [ Number, String ],
      default: 400
    },
    statistics: {
      type: [ Array, Boolean ],
      default: undefined
    },
    search: {
      type: [ Array, Boolean ],
      default: undefined
    },
    opgroup: {
      type: Boolean,
      default: false
    },
    opfix: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    },
    operations: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableOperations: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataFilter: {
      type: Function,
      default: undefined
    },
    handleCellClick: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      dialogShow: false,
      size: 10,
      thisFields: [],
      thisDataFilter: undefined,
      table: {
        loading: true,
        data: [],
        total: 0,
        current: 1,
      }
    }
  },
  created() {
    this.thisFields = this.fields
    this.thisDataFilter = this.dataFilter
    this.size = this.page
  },
  methods: {
    confirm() {
      this.dialogShow = false
    },
    show() {
      this.dialogShow = true
      this.$nextTick(() => {
        this.$refs['$data-table'].initList()
      })
      // setTimeout(() => {
      //   window.vvm = this
      //   this.$refs['$data-table'].initList()
      // }, 100)
    },
    close() {
      this.dialogShow = false
    },
    hide() {
      this.dialogShow = false
    },
    initList() {
      this.$refs['$data-table'].initList()
    },
    getSelection() {
      return this.$refs['$data-table'].getSelection()
    },
  }
}
</script>
<style lang="scss" scoped>
.data-table-container {
  padding: 20px;
  background-color: #ffffff;
  margin-top: -30px;
}
.check-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 5px;
  .table-button {
    background-color: #FA541C;
    color: #ffffff;
    border-color: #FA541C;
    &:HOVER {
      border-color: #FB7B50;
      background-color: #FB7B50;
      color: #ffffff;
    }
  }
}
.data-table {
  min-height: 400px;

  .el-table__body-wrapper {
    min-height: 400px;
  }
}

.table {
  background-color: #ffffff;
}

.checkbox {
  margin-bottom: 10px;
  margin-right: 60px;
}
</style>
